"use strict";
/// <reference path="../types/Jsts.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Point_1 = __importDefault(require("./Point"));
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryType_1 = require("./GeometryType");
var GeometryCollectionBase_1 = __importDefault(require("./GeometryCollectionBase"));
var MultiPoint = /** @class */ (function (_super) {
    __extends(MultiPoint, _super);
    function MultiPoint(points) {
        return _super.call(this, points) || this;
    }
    Object.defineProperty(MultiPoint.prototype, "type", {
        get: function () {
            return GeometryType_1.GeometryType.MultiPoint;
        },
        enumerable: true,
        configurable: true
    });
    MultiPoint.prototype._ts = function () {
        return Geometry_1.default._factory.createMultiPoint(this.children.map(function (c) { return c._ts(); }));
    };
    MultiPoint.prototype._clone = function (convert) {
        return new MultiPoint(this._cloneChildren(convert));
    };
    MultiPoint._from = function (multiPoint) {
        return new MultiPoint(multiPoint.getCoordinates().map(function (c) { return new Point_1.default(c.x, c.y); }));
    };
    return MultiPoint;
}(GeometryCollectionBase_1.default));
exports.default = MultiPoint;
